import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
export function usePublishedEntity(publishedClient, reference) {
    const fetcher = useCallback(([_action, reference]) => fetchEntity(publishedClient, reference), [publishedClient]);
    const { data, error } = useSWR(reference ? CACHE_KEYS.publishedEntity(reference) : null, fetcher);
    return { entity: data, entityError: error };
}
async function fetchEntity(publishedClient, reference) {
    const result = await publishedClient.getEntity(reference);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=usePublishedEntity.js.map